import React, { useEffect, memo } from "react";
import PropTypes from "prop-types";
import { useSelector, useDispatch } from "react-redux";

import Actions from "../../../../../store/actions/customerActions";
import { handle } from "../../../../../common/responseHandler";
import Loader from "../../../../Common/Loader";
import Row from "../../../../Common/Row";
import Table from "../../../../Common/Table";
import NotFound from "../../../../Common/NotFound";
import { getDealerAddress, hasDealerRole } from '../../../../../helpers/customers/dealerHelper';


function PreferredDealer ({customer}) {
    const dispatch = useDispatch();
    const isLoading = useSelector(state => state.loader);
    const {uuid, brand, hasPreferredDealerLoaded, hasPreferredDealerFailed} = customer;

    useEffect(() => {
        if (uuid && !hasPreferredDealerLoaded && !hasPreferredDealerFailed) {
            dispatch(Actions.getPreferredDealer(uuid, brand)).catch(handle);
        }
    }, [uuid, brand, hasPreferredDealerLoaded, hasPreferredDealerFailed, dispatch]);

    const loaded = hasPreferredDealerLoaded || hasPreferredDealerFailed && !isLoading;

    return loaded ?
        <div className="row">
            {(hasPreferredDealerLoaded) ? (
                <div className="col-xs-6">
                    <Table title={`Preferred dealer`}>
                        <Rows customer={customer} />
                    </Table>
                </div>
            ) : (
                <NotFound>No preferred dealer found for this customer...</NotFound>
            )}
            <DealerRole customer={customer}/>
        </div> : <Loader relative/>;
}

const DealerRole = ({ customer }) => {
    return <div className="col-xs-6">
        <Table title={`Dealer Role`}>
            <Rows customer={customer} isDealerRole />
        </Table>
    </div>;
};

const Rows = memo(({ customer, isDealerRole }) => {
	return (
        isDealerRole ? <>
                <Row label={`Dealer role active`} value={hasDealerRole(customer) ? `YES` : `NO`} />
                <Row label={`Activated by`} value={customer.dealerRoleModifiedBy} />
                <Row label={`Activated on`} value={customer.dealerRoleModifiedOn} />
            </> :
            <>
                <Row label={`Dealer ID`} value={customer.preferredDealerId} />
                <Row label={`Dealer name`} value={customer.preferredDealerName} />
                <Row label={`Dealer address`} value={getDealerAddress(customer.preferredDealerAddress)} />
            </>
	);
});

Rows.displayName = `Rows`;
PreferredDealer.displayName = `Preferred dealer`;
PreferredDealer.propTypes = {
    customer: PropTypes.object
};

export default PreferredDealer;